export const OPPORTUNITIES_MESSAGES_ELEMENTS = {
  FEATURE_ANN: 'opportunitiesFeatureAnn',
};

export const OPPORTUNITIES_BANNER_TYPE = {
  FEATURE_ANNOUNCEMENT: 'featureAnnouncement',
  NEW_OPPORTUNITIES: 'newOpportunities',
  NO_BANNER: 'noBanner',
};
